/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HealthControllerCheckQueryResponse } from "../../models/healthController/HealthControllerCheck";

function getHealthControllerCheckUrl() {
  const res = { method: 'GET', url: `/health` as const }  
  return res
}

/**
 * @summary Basic health check
 * {@link /health}
 */
export async function healthControllerCheck(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<HealthControllerCheckQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getHealthControllerCheckUrl().url.toString(), ... requestConfig })  
  return res.data
}